import {
  Navigate,
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import RootRoute from "RootRoute";
import Layout from "../layout";
import { APP_URL } from "../utils/defines";
import { HomePage } from "./HomePage";
import DatasourcePage from "./DatasourcePage";
import Template from "./template";
import LoggedInCallbackRoute from "components/LoggedInCallbackRoute";
import RouteErrorBoundary from "components/RouteErrorBoundary";
import { GridPage } from "./GridPage";
import WidgetInputPage from "./widgets/WidgetInputPage";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootRoute />} errorElement={<RouteErrorBoundary />}>

      <Route path={APP_URL.Loggedin} element={<LoggedInCallbackRoute />} />
      <Route path={APP_URL.Base} element={<Layout />} errorElement={<RouteErrorBoundary />}>
        <Route index element={<HomePage />} />
        <Route path="home" element={<Navigate to="/" />} />
        {/* <Route path={APP_URL.Login} element={<LoginPage />} /> */}

        <Route path="layout/:layoutId?" element={<GridPage />} />
        <Route path="datasource" element={<DatasourcePage />} />
        <Route path="layout/:layoutId/widgets/:widgetType" element={<WidgetInputPage />} />

        <Route path={APP_URL.Template}>
          <Route path="" element={<Template />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Route>
  )
);
